<script>
export default {
  name: 'Tab',
  props: {
    optionList: {
      type: Array,
      default: () => []
    },
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
    }
  },
  mounted() {
    this.setLinePosition(this.currentIndex)
  },
  methods: {
    setLinePosition(i) {
      let doc = document.getElementsByClassName('bottom-line')[0]
      const width = this.$refs.tabItem[i].clientWidth // 在页面上返回内容的可视宽度（不包括边框，边距或滚动条）
      const left = this.$refs.tabItem[i].offsetLeft // 返回当前元素的相对水平偏移位置的偏移容器
      doc.style.width = `${width}px`
      doc.style.transform = `translateX(${left}px)`
      doc.style.transition = 'ease-in-out .2s'
    },
    onTabClick(v, i) {
      this.setLinePosition(i)
      this.$emit('onTabClick', v, i)
    }
  }
}
</script>

<template>
  <div class="tab-container">
    <div
      v-for="(v, i) in optionList"
      :key="`tab-item-${i}`"
      ref="tabItem"
      class="tab-item"
      :class="{'tab-item-active': currentIndex === i}"
      @click="onTabClick(v, i)"
    >
      <p class="item-label">{{ v.label }}</p>
    </div>
    <div v-if="optionList.length" class="bottom-line"></div>
  </div>
</template>

<style lang="scss" scoped>
.tab-container {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  column-gap: 56px;
  position: relative;
  overflow-x: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
  .tab-item {
    cursor: pointer;
    .item-label {
      font-size: 21px;
      color: #333;
    }
  }
  .tab-item-active {
    position: relative;
    .item-label {
      font-size: 21px;
      color: #333;
      font-weight: bold;
    }
    // &::after {
    //   content: '';
    //   position: absolute;
    //   width: 20px;
    //   height: 4px;
    //   background-color: #70B19C;
    //   border-radius: 2px;
    // }
  }
  .bottom-line {
    width: 20px;
    height: 4px;
    background-color: #70B19C;
    border-radius: 2px;
    position: absolute;
    bottom: 0;
  }
}
</style>
